import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function MentorMercadoLivre() {
  const { token } = useAuth();
  const [conectado, setConectado] = useState(null); // null = carregando
  const [link, setLink] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [resultado, setResultado] = useState(null); // { fotoBase64, titulo }

  const checarStatus = () => {
    api.get('/oauth/ml/status', token)
      .then(dados => setConectado(!!dados.conectado))
      .catch(() => setConectado(false));
  };

  useEffect(() => { checarStatus(); }, [token]);

  const conectarMercadoLivre = async () => {
    try {
      const dados = await api.get('/oauth/ml/start', token);
      if (dados.authUrl) {
        const popup = window.open(dados.authUrl, '_blank', 'width=500,height=700');
        const intervalo = setInterval(() => {
          if (popup && popup.closed) {
            clearInterval(intervalo);
            checarStatus();
          }
        }, 1000);
      }
    } catch {
      setErro('Não consegui iniciar a conexão com o Mercado Livre.');
    }
  };

  const buscarFoto = async () => {
    if (!link.trim()) return;
    setCarregando(true);
    setErro('');
    setResultado(null);
    try {
      const dados = await api.post('/ml-foto', { url: link.trim() }, token);
      setResultado(dados);
    } catch (err) {
      setErro(err.message || 'Não consegui buscar a foto agora.');
    } finally {
      setCarregando(false);
    }
  };

  const baixarFoto = () => {
    if (!resultado?.fotoBase64) return;
    const a = document.createElement('a');
    a.href = resultado.fotoBase64;
    a.download = 'foto-produto.jpg';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  if (conectado === null) {
    return <div style={{padding:'28px 32px',color:'#6B7289'}}>Carregando...</div>;
  }

  return (
    <div style={{padding:'28px 32px',maxWidth:520}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Foto Mercado Livre</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Cole o link de um anúncio e receba a foto principal, pronta pra usar nos estudos de importação</div>
      </div>

      {!conectado ? (
        <div className="card">
          <div style={{fontSize:13,fontWeight:600,marginBottom:8}}>Conectar Mercado Livre</div>
          <div style={{fontSize:12,color:'#6B7289',marginBottom:14,lineHeight:1.6}}>
            Precisa conectar sua conta do Mercado Livre uma vez para liberar essa ferramenta. O token renova sozinho depois.
          </div>
          <button className="btn-primary" onClick={conectarMercadoLivre} style={{padding:'11px 20px'}}>
            Conectar Mercado Livre
          </button>
          {erro && <div style={{background:'#FDEAEA',borderRadius:8,padding:'9px 14px',fontSize:12,color:'#922020',marginTop:12}}>{erro}</div>}
        </div>
      ) : (
        <div className="card">
          <span className="badge badge-green" style={{marginBottom:14,display:'inline-block'}}>✓ Mercado Livre conectado</span>
          <input
            className="input-field"
            type="url"
            placeholder="https://produto.mercadolivre.com.br/MLB-..."
            value={link}
            onChange={e => setLink(e.target.value)}
            style={{marginBottom:10}}
          />
          <button className="btn-primary" onClick={buscarFoto} disabled={carregando} style={{padding:'11px 20px'}}>
            {carregando ? 'Buscando...' : 'Buscar foto'}
          </button>

          {erro && <div style={{background:'#FDEAEA',borderRadius:8,padding:'9px 14px',fontSize:12,color:'#922020',marginTop:12}}>{erro}</div>}

          {resultado && (
            <>
              <img src={resultado.fotoBase64} alt={resultado.titulo} style={{width:'100%',borderRadius:10,marginTop:16,border:'0.5px solid #E4E6EF'}} />
              {resultado.titulo && <div style={{fontSize:12,color:'#6B7289',marginTop:8}}>{resultado.titulo}</div>}
              <div style={{marginTop:10}}>
                <button onClick={baixarFoto}
                  style={{fontSize:12,color:'#1A2ECC',background:'#F0F2F8',border:'none',borderRadius:8,padding:'9px 16px',cursor:'pointer',fontWeight:600}}>
                  Baixar foto
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
